import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    modelValue: _ctx.selectedCompany,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCompany) = $event)),
    placeholder: _ctx.placeholder,
    onChange: _ctx.handleChange
  }, {
    default: _withCtx(() => [
      (_ctx.isSearchModel)
        ? (_openBlock(), _createBlock(_component_el_option, {
            key: 0,
            label: "すべて",
            value: _ctx.ALL
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: item.company_code,
          label: `${item.company_name} - ${item.department_name}`,
          value: item.company_code
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "placeholder", "onChange"]))
}